import axios from "axios";
import { Buffer } from "buffer";

const MAX_IMAGE_SIZE = 10000000
/* ENTER YOUR ENDPOINT HERE */
const API_ENDPOINT = 'https://h1mii3ihig.execute-api.us-east-1.amazonaws.com/uploads?file='
  
  export async function uploadFile(file) {
    var image = "";
    var uploadURL = "";
    var mime = "";
    var fileName = "";
    var fileURL = "";
    var fileSize = 0;
    var message = "";

     async function uploadImage(e) {
        console.log('Upload clicked')
        // Get the presigned URL
        const resposta = await axios({
          method: 'GET',
          url: API_ENDPOINT + fileName
        })

        const response = resposta?.data;

        const fileBase64 = image.split(',')[1];
        console.log('Response: ', response, mime, API_ENDPOINT + fileName)
        // console.log('Uploading: ', image)
        // console.log('Uploading 64: ', fileBase64)

        let binary = Buffer.from(fileBase64, "base64");
        let array = []
        for (var i = 0; i < binary.length; i++) {
          array.push(binary[i])
        }
        fileURL = response.url
        let blobData = new Blob([new Uint8Array(array)], {type: mime})
        console.log('Uploading to: ', response.uploadURL)
        message = 'Uploading file ' +  fileName
        const result = await fetch(response.uploadURL, {
          method: 'PUT',
          body: blobData
        })
        console.log('Result: ', result)
        // Final URL for the user doesn't need the query string params
        uploadURL = response.uploadURL
        image = ''
        message = ''
        return response;
      }
    
      async function createImage(file) {
        // var image = new Image()
        console.log('IMAGE', JSON.stringify(file.name))
        mime = file['type']
        fileName = file.name;
        let reader = new FileReader()
        reader.onload = (e) => {
          console.log('length: ', e.target.result.includes('data:'+ mime))
          const fileSize = (e.target.result.length/(1024*1024)).toFixed(2)
          const message = 'Readed file ' +  fileName
          image = e.target.result
        }
        await reader.readAsDataURL(file)
        return file.name;
      }
    




    image = ''
    fileURL = '';
    fileName = await createImage(file);
    const rsp = await uploadImage(file);
    return rsp;

  }